export const generateEmailAndNames = (selectedContacts: { id: number, email: string, name: string }[]) => {
  const selectedNames = selectedContacts.map(({ name }) => name).join(', ');
  const selectedEmails = selectedContacts.map(({ email }) => email).join(';');

  return { selectedNames, selectedEmails };
};
